<template>
  <section>
    <!--工具条-->
    <el-col :span="15" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
    </el-col>

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>

    <el-table :data="tableData" border v-loading="listLoading">
      <el-table-column label="专题ID" prop="id" align="center"></el-table-column>
      <el-table-column label="专题标题" prop="title" align="center"></el-table-column>
      <el-table-column label="创建时间" prop="create_time" align="center"></el-table-column>
      <el-table-column label="状态" prop="status" align="center">
        <template scope="scope">
          {{shanchustatus[scope.row.status]}}
        </template>
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button size="small" @click="editHandler(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible" size="small">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="专题名称" prop="title">
          <el-input v-model="addForm.title" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        
        <el-form-item label="专题图片" prop="pic">
          <el-upload
            multiple
            action="https://up.qbox.me"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="handleBeforeUpload"
            :data="uploadForm"
            :file-list="fileListPro"
            list-type="picture"
            :show-file-list="false">
            <el-button size="small" type="primary">点击多选上传</el-button>
          </el-upload>
          
          <!-- 图片排序与操作列表 -->
          <div class="image-sort-container" v-if="fileListPro.length > 0">
            <div v-for="(file, index) in fileListPro" :key="index" class="image-sort-item">
              <img :src="file.url" class="sort-img">
              <div class="sort-btns">
                <el-button type="text" size="mini" icon="el-icon-arrow-left" :disabled="index === 0" @click="moveImage(index, 'up')">前移</el-button>
                <el-button type="text" size="mini" icon="el-icon-arrow-right" :disabled="index === fileListPro.length - 1" @click="moveImage(index, 'down')">后移</el-button>
                <el-button type="text" size="mini" style="color: #ff4949" @click="deleteImage(index)">删除</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
      
        <el-form-item label="专题状态" prop="status">
          <el-switch
            v-model="addForm.status"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='0'
            off-value='1'>
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible" size="small">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="专题名称" prop="title">
          <el-input v-model="editForm.title" auto-complete="off" size="small" required></el-input>
        </el-form-item>

        <el-form-item label="专题图片" prop="pic">
          <el-upload
            multiple
            action="https://up.qbox.me"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :before-upload="handleBeforeUpload"
            :data="uploadForm"
            :file-list="fileListPro"
            list-type="picture"
            :show-file-list="false">
            <el-button size="small" type="primary">点击多选上传</el-button>
          </el-upload>
          
          <!-- 图片排序与操作列表 -->
          <div class="image-sort-container" v-if="fileListPro.length > 0">
            <div v-for="(file, index) in fileListPro" :key="index" class="image-sort-item">
              <img :src="file.url" class="sort-img">
              <div class="sort-btns">
                <el-button type="text" size="mini" icon="el-icon-arrow-left" :disabled="index === 0" @click="moveImage(index, 'up')">前移</el-button>
                <el-button type="text" size="mini" icon="el-icon-arrow-right" :disabled="index === fileListPro.length - 1" @click="moveImage(index, 'down')">后移</el-button>
                <el-button type="text" size="mini" style="color: #ff4949" @click="deleteImage(index)">删除</el-button>
              </div>
            </div>
          </div>
        </el-form-item>
        
        <el-form-item label="专题状态" prop="status">
          <el-switch
            v-model="editForm.status"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='0'
            off-value='1'>
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
  import {getQiniuToken} from '../../static/js/token.js'
  import {formatDate} from '../../static/js/date.js';
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        updateProVisible: false,
        addForm: {
          title: '',
          pic: '',
          create_time: '',
          status: '0',
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        shanchustatus: basicdata.status,
        imageUrl: '',
        imageName: '',
        proPic: [],
        fileListPro: []
      }
    },
    methods: {
      // 统一处理上传前逻辑：生成本地预览占位，严格保证顺序
      handleBeforeUpload(file) {
        let imageName = 'zhuanti/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        if (mime) {
          imageName += '.' + mime;
        }
        this.uploadForm.key = imageName;
        let qiniuUrl = basicdata.picUrl + imageName;

        // 生成本地预览地址，提升交互体验
        let localPreviewUrl = URL.createObjectURL(file);

        this.proPic.push(qiniuUrl); // 存放最终提给后端的 URL
        this.fileListPro.push({
          name: imageName,
          url: localPreviewUrl,
          uid: file.uid
        });
        return true;
      },

      // 统一处理上传成功逻辑：将本地预览替换为七牛云远程链接
      handleUploadSuccess(response, file, fileList) {
        let targetFile = this.fileListPro.find(item => item.uid === file.uid);
        if (targetFile) {
          targetFile.url = basicdata.picUrl + response.key;
        }
      },

      // 统一处理上传失败逻辑：移除未上传成功的项
      handleUploadError(error, file, fileList) {
        console.log(error);
        this.$message.error('图片上传异常，请联系管理员');
        this.fileListPro = this.fileListPro.filter(item => item.uid !== file.uid);
        this.proPic = this.fileListPro.map(item => item.url);
      },

      // 动态调整图片顺序方法
      moveImage(index, direction) {
        let targetIndex = direction === 'up' ? index - 1 : index + 1;
        
        // 1. 交换前端显示的 fileList 元素位置
        let tempFile = this.fileListPro[index];
        this.$set(this.fileListPro, index, this.fileListPro[targetIndex]);
        this.$set(this.fileListPro, targetIndex, tempFile);
        
        // 2. 交换实际提交给后端的 proPic 数组里的图片 URL 顺序
        let tempPic = this.proPic[index];
        this.$set(this.proPic, index, this.proPic[targetIndex]);
        this.$set(this.proPic, targetIndex, tempPic);
      },

      // 手动删除图片
      deleteImage(index) {
        this.fileListPro.splice(index, 1);
        this.proPic.splice(index, 1);
      },

      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getList(this.query);
      },
      //获取专题列表
      getList(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/zhuanti/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
          this.listLoading = false;
        })
      },
      
      //新增数据提交
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.pic = this.proPic.toString();
              para.status = parseInt(para.status);
              
              this.$axios.post(config.api_url + '/zhuanti', para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.fileListPro = [];
                  this.proPic = [];
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = Object.assign({}, row);
        this.editForm.status = row.status.toString();
        
        if (row.pic) {
          this.proPic = row.pic.split(',').filter(item => item !== '');
        } else {
          this.proPic = [];
        }
        
        let that = this;
        this.fileListPro = [];
        this.proPic.forEach(function (item, i) {
          that.fileListPro.push({
            name: item.replace(basicdata.picUrl, ''),
            url: item
          })
        });
      },
      
      //修改提交
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.pic = this.proPic.toString();
              para.status = parseInt(para.status);
              
              this.$axios.put(config.api_url + '/zhuanti', para).then(response => {
                if(response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.fileListPro = [];
                  this.proPic = [];
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },

      addHandler() {
        this.addFormVisible = true;
        this.proPic = [];
        this.fileListPro = [];
      }
    },
     
    created() {
      this.search();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
  .spec_border {
    border: 1px solid #dfe6ec;
    padding: 25px 30px 25px 20px;
    margin-bottom: 20px;
  }
  .select-goods {
    width: 100%;
  }
  .select-goods .goods-tree {
    width: 30%;
    height: 300px;
    overflow-y: scroll;
    float: left;
  }
  .select-goods .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    width: 60%;
    margin-left: 40%;
    height: 300px;
    overflow-y: scroll;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .select-goods .no-goods {
    text-align: center;
    color: #5e7382;
    padding-top: 30%;
  }

  /* 自定义图片排序样式 (移植自商品详情) */
  .image-sort-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    border: 1px dashed #c0ccda;
    padding: 10px;
    background: #fbfdff;
    border-radius: 6px;
  }
  .image-sort-item {
    margin: 5px;
    padding: 5px;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    background: #fff;
    text-align: center;
    width: 120px;
  }
  .sort-img {
    width: 110px;
    height: 110px;
    object-fit: contain;
    display: block;
    margin-bottom: 5px;
  }
</style>


// WEBPACK FOOTER //
// zhuanti.vue?0360859c